@if (loading && !loaded) {
    <div class="status"><mat-spinner diameter="24"></mat-spinner><span>Loading your support tickets&hellip;</span></div>
}@else if (error) {
    <div class="status error">
        <mat-icon>error_outline</mat-icon>
        <span>{{error}}</span>
        <button mat-button color="accent" (click)="refreshTickets()" [disabled]="loading">Try again</button>
    </div>
}@else if (data.length === 0) {
    <p class="empty">You have no open support tickets. Use Create support ticket to ask a question, report a problem or request a feature.</p>
}@else {
    <p class="summary">{{openCount}} open &middot; resolved tickets are shown for 30 days. The support team replies by email.</p>
    <app-table [columns]="columns" [data]="data"></app-table>
}
